import React from 'react'
import classes from './style.module.scss'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import useStyles from 'isomorphic-style-loader/useStyles'
import withSource from '../../hocs/source-scoll'
import { getSensorsUrl } from '../../utils/sensor'

const handleAClick = (e, sensors) => {
    e.preventDefault()
    const href = e.currentTarget?.href
    window.location.href = getSensorsUrl(href, {
        resourcepage_title: sensors?.title,
        resource_type: sensors?.type,
        resource_content: sensors?.content,
        resource_position: sensors?.position,
    })
}


export default withSource(props => {
    useStyles(classes)
    const { href, title, src, lazy, width, height, innerRef, sensors } = props
    let aspectRatio
    if (width && height) {
        aspectRatio = `${Math.floor(height * 100 / width)}%`
    }
    return <a ref={innerRef}
        data-position={`${sensors?.position}`}
        data-type={sensors?.type}
        data-content={sensors?.content}
        data-title={sensors?.title}
        className={classes.ImageBlock} href={href} onClick={e => handleAClick(e, sensors)}>
        <div className={classes.Image} style={{ paddingTop: aspectRatio }}>
            {
                lazy ? <LazyLoadImage style={{ position: aspectRatio ? 'absolute' : 'static' }} alt={title} src={src} /> : <img style={{ position: aspectRatio ? 'absolute' : 'static' }} alt={title} src={src} />
            }
        </div>
    </a>
})